<template>
  <svg viewBox="0 0 100 100">
    <circle v-for="n in 7" :key="n" :cx="50" :cy="50" :r="n * 7" :fill="fillColor(n)" />
  </svg>
</template>

<script>
export default {
  name: 'Circles',
  props: {
    color: {
      type: String,
      default: "green"
    },
  },
  computed: {
    fillColor() {
      return(n) => {
        if(this.color === 'yellow') {
          return `#e5dc0a${Math.floor(n + 35)}`
        } else {
          return `#c5ce19${Math.floor(n + 42)}`
        }
      }
    }
  },
};
</script>
